import { useState, useEffect, useRef } from 'react';
import { Loader } from 'src/components';
import { Login, Register, NotLoggedIn, AccountSummary, ForgotPassword, ChangePassword, RecoverPassword,
    AccountSettings, EditProfile } from './index';
import { useAuth } from 'src/utils';
import { useSnackbar, useIsMobile } from 'src/hooks';
import './profile.css';

export default function Profile() {
    const { user, isFetching } = useAuth();
    const [currentView, setCurrentView] = useState(user !== null ? "AccountSummary" : "NotLoggedIn");
    const { openSnackbar } = useSnackbar();
    const isMobile = useIsMobile();
    const scrollRef = useRef(null);
    
    useEffect(() => {
        if (user === null && currentView === "AccountSettings") {
            setCurrentView("NotLoggedIn");
        }
        else if (user && currentView === "NotLoggedIn") {
            setCurrentView("AccountSummary");
        }
    }, [user, currentView, isFetching]);

    const handleCurrentViewChange = view => {
        setCurrentView(view);
    };

    const handleSuccess = (message) => {
        openSnackbar(message, 'success');
    };

    const handleFailure = (message) => {
        openSnackbar(message, 'error');
    };

    const userAccountViews = {
        "NotLoggedIn": (<NotLoggedIn handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess}></NotLoggedIn>),
        "Login": (<Login handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess}></Login>),
        "Register": (<Register handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess}></Register>),
        "AccountSummary": (<AccountSummary scrollRef={scrollRef} handleCurrentViewChange={handleCurrentViewChange}></AccountSummary>),
        "ForgotPassword": (<ForgotPassword handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess}></ForgotPassword>),
        "RecoverPassword": (<RecoverPassword handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess}></RecoverPassword>),
        "ChangePassword": (<ChangePassword handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess}></ChangePassword>),
        "AccountSettings": (<AccountSettings handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess}></AccountSettings>),
        "EditProfile": (<EditProfile handleCurrentViewChange={handleCurrentViewChange} handleSuccess={handleSuccess} handleFailure={handleFailure}></EditProfile>),
    };

    return (
        <div 
            ref={scrollRef}
            className="scrollBox"
            style={{
                width: '100%', 
                paddingLeft: isMobile ? '35px' : '20px',
                paddingRight: isMobile ? '35px' : '20px',
                maxWidth: '400px', 
                marginTop: isMobile ? 'calc(20px + var(--safe-area-top))' : '0px', 
                minHeight: '300px'}}>

            {isFetching ? 
                <Loader /> 
            : 
                <>{ userAccountViews[currentView] }</>
            }

        </div>
    );
}
